<template>
  <div id="app">
    <a-spin :spinning="spinning">
      <!-- 你的页面内容或组件会显示在这里 -->
      <router-view></router-view> <!-- 用于渲染匹配的路由组件 -->
    </a-spin>
  </div>
</template>

<script>
import { defineComponent, onMounted, reactive, ref } from 'vue';
import CryptoJS from 'crypto-js';

export default defineComponent({
  setup() {
    const spinning = ref(false);
    const state = reactive({
      url: '',
      encryptedKey1: '',
      decryptedKey: '',
      key: '13395321251', // 32位key
    });

    // 页面加载时调用 getUserQlCode
    onMounted(() => {
      getUserQlCode();
    });

    // 加密算法
    const handlecrypet1 = () => {
      spinning.value = true;
      const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Hex.parse(state.decryptedKey), CryptoJS.enc.Utf8.parse(state.key), {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      });
      state.encryptedKey1 = encrypted;
      console.log(encrypted.ciphertext.toString(CryptoJS.enc.Hex), '加密');
      setTimeout(() => {
        spinning.value = false;
      }, 1500);
    };

    // 解密算法
    const handlecrypet = () => {
      const encrypted1 = CryptoJS.enc.Hex.parse(state.encryptedKey1.ciphertext.toString(CryptoJS.enc.Hex));
      const decrypted = CryptoJS.AES.decrypt(encrypted1, CryptoJS.enc.Utf8.parse(state.key), {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      });
      console.log(decrypted.toString(CryptoJS.enc.Utf8)); // 输出解密后的明文密码
    };

    // 获取用户的QR代码并处理相应的重定向
    const getUserQlCode = () => {
      spinning.value = true;
      state.url = Object.fromEntries(new URLSearchParams(decodeURIComponent(window.location.search)));
      const token = `token=${state.url.token}&orgcode=${state.url.orgcode}`;
      
      switch(state.url.id) {
        case '0':
          window.location.href = `https://pt.hisense-plaza.com:4433/workplace?${token}`;
          break;
        case '1':
          window.location.href = `https://pt.hisense-plaza.com:4440/workplace?${token}`;
          break;
        case '1001':
          window.location.href = `https://pt.hisense-plaza.com:8087/webroot/decision/view/report?viewlet=%25E9%259D%2592%25E5%25B2%259B%252F%25E8%2590%25A5%25E8%25BF%2590%25E9%2583%25A8%252F%25E5%25AE%259E%25E6%2597%25B6%25E9%2594%2580%25E5%2594%25AE-%25E5%2593%2581%25E7%2589%258C%25E9%2594%2580%25E5%2594%25AE%25E6%258A%25A5%25E8%25A1%25A8.cpt&person_id=1&op=view`;
          break;
        default:
          console.error('Invalid ID in URL');
      }
      spinning.value = false;
    };

    return {
      handlecrypet1,
      handlecrypet,
      getUserQlCode,
      spinning,
      state,
    };
  },
});
</script>

<style scoped>
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.member-cover {
  width: 60px;
  height: 60px;
}

.members {
  margin-bottom: 80px;
}

.member {
  display: block;
  font-size: 14px;
  line-height: 24px;
  vertical-align: top;
  transition: all 0.3s;
}
</style>
